import { network } from './network';

export async function checkVersion(opts) {
	const res = await network({
		url: '/api/version',
		method: 'get',
		params: {}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function getPushMessages() {
	const res = await network({
		url: '/api/push_messages',
		method: 'get',
		params: {}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}